export const GET_ALL_STATIC_PAGES = "GET_ALL_STATIC_PAGES";
export const GET_ALL_STATIC_PAGES_RESPONSE_SUCCESS =
  "GET_ALL_STATIC_PAGES_RESPONSE_SUCCESS";
